import { FC } from 'react'

type TProps = {}

const ProfilePageContent: FC<TProps> = () => {
  return (
    <div className="flex flex-1 flex-col">
      <div className="flex flex-col p-5 "></div>
    </div>
  )
}

export { ProfilePageContent }
